import React, { useState, useCallback } from 'react';
import { CirclePicker, ColorResult } from 'react-color';
import { IconButton, makeStyles } from '@material-ui/core';
import { ReactComponent as ShirtIcon } from '../../graphics/shirt.svg';

type Props = {
  color: string,
  setColor: (newColor: string) => void;
};

const useStyles = makeStyles({
  root: {
    position: 'relative',
  },
  popover: {
    position: 'absolute',
    zIndex: 2,
    left: 40,
    top: 0,
    backgroundColor: "#bbb",
    borderRadius: 12,
    padding: 12,
  },
  icon: {
    width: 28,
    height: 28,
  },
});

const TeamColorPicker = (props : Props) => {
  const classes = useStyles();

  const [showPicker, setShowPicker] = useState<boolean>(false);
  
  const {
    color,
    setColor,
  } = props;

  const handleChangeComplete = useCallback((colorHandler: ColorResult) => {
    setColor(colorHandler.hex);
    setShowPicker(false);
  }, [setColor]);

  return (
    <div className={classes.root}>
      <IconButton 
        onClick={() => setShowPicker(value=>!value)}
      >
        <ShirtIcon className={classes.icon} fill={color} />
      </IconButton>
      { 
        showPicker && <div className={classes.popover}>
          <CirclePicker 
            colors={
              [
                "#ff1616", 
                "#ff5722", 
                "#ff9800", 
                "#ffeb3b", 
                "#8bc34a", 
                "#009688", 
                "#00bcd4", 
                "#03a9f4", 
                "#3f51b5", 
                "#9c27b0", 
                "#ff6ec7",
                "#ffffff",
                "#607d8b",
                "#000000",
                "#795548", 
              ]
            }
            width="102px"
            circleSize={19}
            onChangeComplete={ handleChangeComplete }
          />
        </div>
      }
    </div>
  )
}

export default TeamColorPicker;